export default __webpack_public_path__ + "static/media/MainApple.dcf8dc3b.svg";